import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../views/buttons/Button";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import wbApi from "../../../API/wbApi";
import { roomPageAction } from "../../../redux/actions/PageAction";
import { CATCH_MESSAGE } from "../../../UtilityFunctions";
import { toast } from "react-toastify";
import ImageRoomBanner from "./ImageRoomBanner";
import VideoRoomBanner from "./VideoRoomBanner";

const EditAboutBanner = () => {
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { page_Id } = useSelector((state: RootState) => state.pages);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeMenuTab, setActiveMenuTab] = useState("Image");
  const pages = ["Image", "Video"];

  const switchMenuTab = (tab: string) => {
    setActiveMenuTab(tab);
    // console.log(tab);
  };
  // useEffect(() => {
  //   aboutPageDataFetching();
  // }, [company_id, template_id]);

  // Fetching About Page Data

  const roomPageDataFetching = async () => {
    try {
      let PageRes = await wbApi.get(
        `/wb-dashboard/fetch-wb-room-page-details/${company_id}/${template_id}/${page_Id}`
      );
      // console.log("aboutPageData", aboutPageData);
      if (PageRes.data.status === 1) {
        dispatch(roomPageAction(PageRes.data));
        const aboutPageAllSec = PageRes.data.all_sections.map((item: any) => {
          return { ...item, isChecked: false };
        });
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };
  return (
    <>
      {/* Sub Header */}
      <div className="wb-subheader">
        {/* BreadCrumbs */}
        <CustomBreadcrumbs
          content={[
            {
              label: "Pages",
              href: "/pages-default",
            },
            {
              label: `Default Pages`,
              href: "/pages-default",
            },
            {
              label: "Rooms",
              href: "/pages-default/edit-room-page",
            },
            {
              label: "Edit Rooms",
            },
          ]}
        />
        <div className="wb-subheader-rightsec">
          {/* Toggle Button */}
          <div className="header-footer-toggle">
            <ul className="nav nav-tabs">
              {pages.map((tab) => {
                return (
                  <li
                    className="nav-item"
                    role="presentation"
                    key={tab}
                    onClick={() => switchMenuTab(tab)}
                  >
                    <a
                      className={`nav-link ${tab === activeMenuTab ? "active" : ""
                        }`}
                      id={`${tab}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#${tab}`}
                      aria-controls={`#${tab}`}
                      role="tab"
                      aria-selected="true"
                    >
                      {tab.toUpperCase()}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Back Button */}
          <BackButton
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </BackButton>
        </div>
      </div>
      <div className="wb-divider"></div>
      {/* MainContent */}
      {activeMenuTab === "Image" ? (
        <ImageRoomBanner roomPageDataFetching={roomPageDataFetching} />
      ) : (
        <VideoRoomBanner roomPageDataFetching={roomPageDataFetching} />
      )}
    </>
  );
};

export default EditAboutBanner;
